export default [
    { // 교육강좌
        path: 'lect',
        children: [
            { // 강습프로그램 관리
                path: 'crs-pgm-mng',
                redirect: { name: 'CrsPgmList' },
                children: [
                    {
                        path: 'list',
                        name: 'CrsPgmList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/crsPgmMng/CrsPgmMngListView.vue')
                    },
                    {
                        path: 'add',
                        name: 'CrsPgmInsert',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crsPgmMng/CrsPgmMngInsertView.vue'),
                        props: (route) => ({
                            gdsClsfDcd: route.query.gdsClsfDcd || ''
                        })
                    },
                    {
                        path: 'modify',
                        name: 'CrsPgmUpdate',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crsPgmMng/CrsPgmMngUpdateView.vue'),
                        props: (route) => ({
                            gdsClsfDcd: route.query.gdsClsfDcd || '',
                            lsnId: route.query.lsnId || '',
                            gdsId: route.query.gdsId || ''
                        })
                    },
                    {
                        path: 'instr-list-popup',
                        name: 'InstrListPopup',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crsPgmMng/components/CrsPgmInstrListPopup.vue'),
                        props: true
                    },
                    {
                        path: 'instr-add-popup',
                        name: 'InstrAddPopup',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crsPgmMng/components/CrsPgmInstrInsertPopup.vue'),
                        props: true
                    },
                    {
                        path: 'dprcn-list-popup',
                        name: 'CrsPgmDprcnListPopup',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crsPgmMng/components/CrsPgmDprcnListPopup.vue'),
                        props: (route) => ({
                            crdnlId: route.query.crdnlId || '', 
                            lsnId: route.query.lsnId || '',
                            gdsId: route.query.gdsId || '',
                            crdnlYear: route.query.crdnlYear || ''
                        })
                    },
                ]
            },
            { // 강사관리
                path: 'teacher-mng',
                redirect: { name: 'TeacherList' },
                children: [
                    {
                        path: 'list',
                        name: 'TeacherList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/teacherMng/TeacherMngListView.vue')
                    },
                    {
                        path: 'add',
                        name: 'TeacherInsert',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/teacherMng/TeacherMngInsertView.vue')
                    },
                    {
                        path: 'modify/:instrId',
                        name: 'TeacherUpdate',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/teacherMng/TeacherMngUpdateView.vue'),
                        props: true
                    }
                ]
            },
            { // 기수관리
                path: 'crdnl-mng',
                redirect: { name: 'CrdnlList' },
                children: [
                    {
                        path: 'list',
                        name: 'CrdnlList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/crdnlMng/CrdnlMngListView.vue')
                    },
                    {
                        path: 'add',
                        name: 'CrdnlInsert',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crdnlMng/CrdnlMngInsertView.vue')
                    },
                    {
                        path: 'modify/:crdnlId',
                        name: 'CrdnlUpdate',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/crdnlMng/CrdnlMngUpdateView.vue'),
                        props: true
                    }
                ]
            },
            { // 공휴일 관리
                path: 'holiday-mng',
                redirect: { name: 'HolidayMngList' },
                children: [
                    {
                        path: 'list',
                        name: 'HolidayMngList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/holidayMng/HolidayListContainer.vue')
                    },
                    {
                        path: 'add',
                        name: 'HolidayMngInsert',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/holidayMng/HolidayInsertView.vue'),
                        props: true
                    },
                    {
                        path: 'modify/:hldyId',
                        name: 'HolidayMngUpdate',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/holidayMng/HolidayUpdateView.vue'),
                        props: true
                    }
                ]
            },
            { // 대기자관리
                path: 'wait-mng',
                redirect: { name: 'WaitList' },
                children: [
                    {
                        path: 'list',
                        name: 'WaitList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/waitMng/WaitMngListView.vue')
                    }
                ]
            },
            { // 추첨관리
                path: 'lot-mng',
                redirect: { name: 'LotList' },
                children: [
                    {
                        path: 'list',
                        name: 'LotList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/lotMng/LotMngListView.vue')
                    }
                ]
            },
            { // 예약현황
                path: 'rsvt-cur-mng',
                redirect: { name: 'RsvtCurList' },
                children: [
                    {
                        path: 'list',
                        name: 'RsvtCurList',
                        meta: { menu: 'lect', keepAlive: true },
                        component: () => import('@/pages/resvMng/lect/rsvtCurMng/RsvtCurMngListView.vue')
                    },
                    {
                        path: 'add',
                        name: 'RsvtCurInsert',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/rsvtCurMng/RsvtCurMngInsertView.vue')
                    },
                    {
                        path: 'modify/:atlncId',
                        name: 'RsvtCurUpdate',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/rsvtCurMng/RsvtCurMngUpdateView.vue'),
                        props: true
                    },
                    {
                        path: 'crs-prgrm-list-popup',
                        name: 'CrsPrgrmListPopup',
                        meta: { menu: 'lect', keepAlive: false },
                        component: () => import('@/pages/resvMng/lect/rsvtCurMng/components/CrsPrgrmListPopup.vue'),
                        props: true
                    },
                    {
                        path: 'payment-popup',
                        name: 'LectPaymentPopup',
                        meta: { menu: 'lect', keepAlive: false, layout: 'blank' },
                        component: () => import('@/pages/resvMng/common/popup/PaymentPopup.vue'),
                        props: true
                    },
                    {
                        path: 'payment-history-popup',
                        name: 'LectPaymentHistoryPopup',
                        meta: { menu: 'lect', keepAlive: false, layout: 'blank' },
                        component: () => import('@/pages/resvMng/common/popup/PaymentHistoryPopup.vue'),
                        props: true
                    }
                ]
            },
        ]
    },
]
